var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import copy from "copy-to-clipboard";
import { CouponType } from "../../../services/banner";
import { ConponWrapper } from "./styles";
import { Single } from "./Components/Single";
import { Double } from "./Components/Double";
import { Three } from "./Components/Three";
import { CouponToast } from "./Components/Toast";
export const SuccessCode = "1000000";
const Coupon = (props) => {
    const { positionId, columnSize, type, language, spmClick, coupons } = props;
    const [showToast, setShowToast] = React.useState(false);
    const [status, setStatus] = React.useState(0);
    const onClickCopyBtn = (code) => __awaiter(void 0, void 0, void 0, function* () {
        copy(code);
        setShowToast(true);
    });
    const onClickReceiveCoupon = (code) => {
        props.getCoupons(code).then((res) => {
            var _a;
            setShowToast(res.code === "1000000");
            setStatus((_a = res.info) === null || _a === void 0 ? void 0 : _a.status);
        });
    };
    const handleClick = (code, index = 0) => {
        spmClick && spmClick(index);
        if (type === CouponType.CopyCoupon) {
            onClickCopyBtn(code);
        }
        else {
            onClickReceiveCoupon(code);
        }
    };
    const renderCoupon = () => {
        const commonProps = {
            coupons,
            handleClick,
        };
        switch (columnSize) {
            case 1:
                return React.createElement(Single, Object.assign({}, commonProps));
            case 2:
                return React.createElement(Double, Object.assign({}, commonProps));
            case 3:
                return React.createElement(Three, Object.assign({}, commonProps));
            default:
                return React.createElement(Single, Object.assign({}, commonProps));
        }
    };
    const handleClose = () => {
        setShowToast(false);
    };
    return (React.createElement(ConponWrapper, { id: positionId, col: columnSize },
        showToast && (React.createElement(CouponToast, { type: type, status: status, language: language, handleClose: handleClose })),
        renderCoupon()));
};
export default Coupon;
